import {hostName} from "../../../endpoint";
import {defaultHeaders} from "../../../headers";

export const create = async (group) => {
  try {
    const result = await fetch(`${hostName}/business/team-group`, {
      method: "POST",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(group),
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
